const neptunusQuiz = [ 
    {
    question: "Neptunus adalah planet ke berapa dari Matahari?",
    options: ["6", "7", "8", "9"],
    answer: 2,
  },
  {
    question: "Neptunus termasuk dalam jenis planet apa?",
    options: [
      "Planet Terestrial",
      "Planet Raksasa Gas",
      "Planet Es",
      "Planet Kecil",
    ],
    answer: 2,
  },
  {
    question: "Warna dominan Neptunus adalah?",
    options: [
      "Merah",
      "Hijau",
      "Biru",
      "Kuning",
    ],
    answer: 2,
  },
  {
    question: "Mengapa Neptunus terlihat berwarna biru?",
    options: [
      "Karena lautan",
      "Karena gas metana di atmosfer",
      "Karena debu es",
      "Karena cahaya Matahari",
    ],
    answer: 1,
  },
  {
    question: "Neptunus memiliki angin yang?",
    options: [
      "Sangat lemah",
      "Sama seperti Bumi",
      "Paling kencang di tata surya",
      "Tidak ada angin",
    ],
    answer: 2,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Neptunus?",
    options: ["2", "7", "14", "30"],
    answer: 2,
  },
  {
    question: "Bulan terbesar Neptunus bernama?",
    options: [
      "Titan",
      "Triton",
      "Europa",
      "Ganymede",
    ],
    answer: 1,
  },
  {
    question: "Apakah Neptunus memiliki cincin?",
    options: [
      "Tidak",
      "Ya, tetapi sangat tipis",
      "Ya, sangat besar",
      "Hanya satu cincin",
    ],
    answer: 1,
  },
  {
    question: "Suhu Neptunus secara umum?",
    options: [
      "Sangat panas",
      "Sedang",
      "Sangat dingin",
      "Sama seperti Bumi",
    ],
    answer: 2,
  },
  {
    question: "Mengapa Neptunus jarang diteliti langsung?",
    options: [
      "Karena terlalu kecil",
      "Karena terlalu panas",
      "Karena sangat jauh dari Bumi",
      "Karena tidak menarik",
    ],
    answer: 2,
  },
]

export default neptunusQuiz;